import { prefersReducedMotion } from '@theme/utilities';

class ScrollIndicator extends HTMLElement {
  /** @type {HTMLButtonElement | null} */
  #button = null;

  connectedCallback() {
    this.#button = this.querySelector('button');
    this.#button?.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.#button?.removeEventListener('click', this.#handleClick);
    this.#button = null;
  }

  #handleClick = (event) => {
    event.preventDefault();

    const currentSection = this.closest('.shopify-section');
    const nextSection = currentSection?.nextElementSibling;

    if (!(nextSection instanceof HTMLElement)) return;

    const behavior = prefersReducedMotion() ? 'instant' : 'smooth';
    const headerOffset =
      parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 0;
    const top = nextSection.getBoundingClientRect().top + window.scrollY - headerOffset;

    window.scrollTo({ top, behavior });
  };
}

if (!customElements.get('scroll-indicator')) {
  customElements.define('scroll-indicator', ScrollIndicator);
}
